import { render, staticRenderFns } from "./Shelve.vue?vue&type=template&id=414b2a4a&"
import script from "./Shelve.vue?vue&type=script&lang=js&"
export * from "./Shelve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports